import { render, staticRenderFns } from "./PopupDeleteGroupChild.vue?vue&type=template&id=18327676"
import script from "./PopupDeleteGroupChild.vue?vue&type=script&lang=js"
export * from "./PopupDeleteGroupChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports